<template lang="pug">
  div.kids
    HeaderTheme(v-if="banner", :imgUrl="banner.src")
      template(slot="description")
        p.subtitle Kids' Snow
        p.title Don't Sweat the Weather
        p.intro With graduated compression for increased warmth and twisted yarns for extra durability, the downhill adventures never have to end.
        div.button-groups
          a.button Shop New Arrivals
    SubjectList(v-if="list", :list="list")
    //- KidsSubject
</template>
<script>
import HeaderTheme from '@/components/HeaderTheme.vue'
import SubjectList from '@/components/SubjectList.vue'
import KidsSubject from '@/components/kids/KidsSubject.vue'
import { getMainCategoryPage } from '@/services/index'
export default {
  name: 'Kids',
  components: {
    HeaderTheme,
    SubjectList,
    KidsSubject
  },
  data () {
    return {
      banner: null,
      list: null
    }
  },
  created () {
    const params = {
      navigation_id: this.$route.query.id
    }
    getMainCategoryPage(params)
      .then(res => {
        this.banner = res.data.banner
        this.list = res.data.sub
      })
  }
}
</script>
<style lang="scss" scoped>
.kids {

}
</style>
